import script from "./DayHoursTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayHoursTableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DayHoursTableComponent.vue?vue&type=style&index=0&id=5b6254db&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6254db"]])

export default __exports__